<template>
  <v-dialog
  v-model="visible"
  max-width="400px"
  persistent
  >
    <v-card>
      <v-card-title
        class="headline font-weight-medium white--text"
        style="background-color: #0b4f6a; font-size: 20px;"
      >
        SUCESSO
      </v-card-title>
      <v-card-text class="text-xs-center py-4">
        <div style="color: rgba(0, 0, 0, 0.7); font-size: 15px;">
          Proposta Emitida com Sucesso
        </div>

        <v-icon
          large
          color="green"
          class="mt-4"
          style="font-size: 48px;"
        >
          check_circle
        </v-icon>
      </v-card-text>
    
      <v-card-actions class="justify-center pb-4">
        <v-btn
          class="button-permanecer"
          flat
          @click="onClose"
        >
          FECHAR
        </v-btn>
      </v-card-actions>
    
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalSucesso',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    onClose() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.v-dialog__content {
  align-items: center;
}

.btn-confirm {
  background-color: #0b4f6a;
  color: white;
  text-transform: uppercase;
  font-weight: 600;
  min-width: 160px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/frota/ModalSucesso.vue